import { FC } from 'react'
import { useAppSelector } from '../../store/hooks'
import { SeatingArea as SeatingAreaModel } from '../../models/SeatingArea'
import { selectSeatingAreaById } from '../../store/SeatingAreaReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'

type Props = SBModelComponent<SeatingAreaModel> & {}

const SeatingAreaOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectSeatingAreaById(id!))

  if (!item) {
    return <></>
  }

  return item.name
}

type SeatingAreaOptionType = { Option: typeof SeatingAreaOption }

export { SeatingAreaOption, type SeatingAreaOptionType }
